module.exports = __webpack_public_path__ + "img/customer-pic1.7311c8d1.png";